import React from "react";

const COLORS = {
  gold:   "bg-yellow-500/15 text-yellow-400 border-yellow-600/50",
  red:    "bg-red-500/15 text-red-400 border-red-700/50",
  blue:   "bg-blue-500/15 text-blue-400 border-blue-700/50",
  green:  "bg-green-500/15 text-green-400 border-green-700/50",
  purple: "bg-purple-500/15 text-purple-400 border-purple-700/50",
  orange: "bg-orange-500/15 text-orange-400 border-orange-700/50",
  pink:   "bg-pink-500/15 text-pink-400 border-pink-700/50",
  cyan:   "bg-cyan-500/15 text-cyan-400 border-cyan-700/50",
  zinc:   "bg-zinc-500/15 text-zinc-400 border-zinc-700/50",
};

/** Admin-assigned funny title displayed next to user name in chat. */
export const FunnyTitleBadge = ({ title, color = "gold", className = "" }) => {
  if (!title) return null;
  const cls = COLORS[color] || COLORS.gold;
  return (
    <span
      data-testid="funny-title-badge"
      title={`Status pridelený adminom: ${title}`}
      className={`inline-flex items-center px-1.5 py-0.5 text-[9px] font-mono font-bold uppercase tracking-wider border rounded-sm ${cls} ${className}`}
    >
      {title}
    </span>
  );
};

export const FUNNY_TITLE_PRESETS = [
  "Somroš", "Vymyseľník", "Pirát", "Hlavička", "Inžinierko",
  "Majster cvak", "Frfloš", "Chlap z dielne", "Šéfko",
  "Zvárač sršeň", "Bez chyby", "Šibal", "Tichý expert", "Stará škola",
  "Mladá krv", "Komentátor", "Hĺbavý",
];

export const COLOR_OPTIONS = [
  { id: "gold", label: "Zlatá" },
  { id: "red", label: "Červená" },
  { id: "blue", label: "Modrá" },
  { id: "green", label: "Zelená" },
  { id: "purple", label: "Fialová" },
  { id: "orange", label: "Oranžová" },
  { id: "pink", label: "Ružová" },
  { id: "cyan", label: "Tyrkysová" },
  { id: "zinc", label: "Sivá" },
];

export default FunnyTitleBadge;
